import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./ApplicationSubmitted.css";

const ApplicationSubmitted = () => {
  const location = useLocation();

  // Optional: if later we pass a reference number in the Return URL like:
  // https://yourdomain.com/application-submitted?ref=00Qxxxxxxxxxxxx
  // we can show it here. For now it will just be blank unless present.
  const referenceNumber = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("ref") || "";
  }, [location.search]);

  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    const academyPath = "/academy";

    const redirectTimer = window.setTimeout(() => {
      window.location.assign(academyPath);
    }, 3000);

    const interval = window.setInterval(() => {
      setSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    return () => {
      window.clearTimeout(redirectTimer);
      window.clearInterval(interval);
    };
  }, []);

  return (
    <main className="as-page" aria-live="polite">
      <section className="as-card">
        <header className="as-header">
          <div className="as-icon" aria-hidden="true">
            <span>✨</span>
          </div>

          <h1 className="as-title">Application Submitted</h1>
          <p className="as-subtitle">
            Thank you for applying to be part of <strong>Cause and Impact, Inc.</strong> We’ll review
            your submission within <strong>48–72 hours</strong> and follow up by email.
          </p>
        </header>

        <div className="as-divider" />

        <div className="as-infoGrid">
          <div className="as-info">
            <strong>What happens next:</strong>
            <div className="as-muted">
              Our team will review your mission alignment, fundraising plans, and basic intake details.
              If we need anything else, we’ll reach out with a short list of questions.
            </div>
          </div>

          <div className="as-info">
            <strong>Heads up:</strong>
            <div className="as-muted">
              If you don’t see a confirmation email, check spam/promotions. You can also reach us from
              the “Talk to Our Team” page.
            </div>
          </div>

          {/* Optional (future): reference number */}
          {referenceNumber ? (
            <div className="as-info">
              <strong>Confirmation number:</strong>
              <div className="as-muted as-mono">{referenceNumber}</div>
            </div>
          ) : null}
        </div>

        <div className="as-actions">
          <Link className="as-primaryBtn" to="/academy">
            <span className="as-btnLabel">Go to Impact Academy</span>
          </Link>

          <Link className="as-secondaryBtn" to="/">
            Back to Home
          </Link>
        </div>

        <div className="as-footerNote">
          <div className="as-countdown">
            Redirecting to Impact Academy in <span className="as-pill">{seconds}</span> seconds…
          </div>
        </div>
      </section>
    </main>
  );
};

export default ApplicationSubmitted;
